import { render, staticRenderFns } from "./check.vue?vue&type=template&id=0c82df44&scoped=true"
import script from "./check.vue?vue&type=script&lang=js"
export * from "./check.vue?vue&type=script&lang=js"
import style0 from "./check.vue?vue&type=style&index=0&id=0c82df44&prod&lang=scss&scoped=true"
import style1 from "./check.vue?vue&type=style&index=1&id=0c82df44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c82df44",
  null
  
)

export default component.exports